<template>
  <div class="device-replay-list-search-wrap">
    <el-form ref="form" :model="model" size="small" label-suffix=":" :inline="true" :rules="rules">
      <el-form-item :label="$t('设备类型')" prop="type">
        <el-select
          v-model="model.deviceType"
          collapse-tags
          multiple
          clearable
          :placeholder="$t('请选择')"
        >
          <el-option v-for="v in deviceTypeList" :key="v.value" :label="v.label" :value="v.value">
            <span>{{ v.label }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('设备')" prop="sns">
        <el-select
          v-model="model.sns"
          clearable
          multiple
          collapse-tags
          :placeholder="$t('请选择设备')"
        >
          <el-option v-for="v in deviceList" :key="v.sn" :label="v.name" :value="v.sn">
            <span>{{ v.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('条纹码')" prop="barCode">
        <el-input v-model="model.barCode" />
      </el-form-item>

      <el-form-item :label="$t('报警时间')" prop="dateRange">
        <el-date-picker
          v-model="model.dateRange"
          type="datetimerange"
          :range-separator="$t('至')"
          :start-placeholder="$t('开始日期')"
          :end-placeholder="$t('结束日期')"
          value-format="timestamp"
          @change="dateChange"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="validateEvent" :loading="loading">
          {{ $t('查询') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getDevicesList } from '@/api/baseInfo';
import { isEmpty } from '@/utils/is';

export default {
  inject: ['getDeviceTypeList'],
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    operation: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deviceList: []
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap']),
    deviceTypeList() {
      return this.getDeviceTypeList();
    }
  },
  methods: {
    dateChange(_val) {
      // if (!val || !val[0] || !val[1]) return;
      // const begin = toTimestamp(val[0], 'm');
      // const end = toTimestamp(val[1], 'm');
      // const range = getTime('h') * 24;
      // if (end - begin > range) {
      //   this.model.dateRange.splice(0, Infinity, begin, begin + getTime('h'));
      // } else {
      //   this.model.dateRange.splice(0, Infinity, begin, end);
      // }
    },

    validateEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('search', this.model);
        } else {
          return false;
        }
      });
    },
    async getDeviceList() {
      try {
        const { officeId, deviceType } = this.model;
        const res = await getDevicesList({
          officeId: officeId,
          deviceModel: isEmpty(deviceType) ? this.deviceTypeList.map(e => e.value) : deviceType
        });
        this.deviceList = res.data;
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    'model.officeId': 'getDeviceList',
    'model.deviceType': 'getDeviceList'
  },
  mounted() {
    this.getDeviceList();
  }
};
</script>

<style></style>
